"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montichiari": {
    "68c15a53": [{
      "hkey": "07aa96a6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "borgosotto": [{
      "hkey": "07aa96a6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montichiari"
    }],
    "5b7ce7e6": [{
      "hkey": "07aa96a6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "chiarini": [{
      "hkey": "07aa96a6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montichiari"
    }],
    "6d2fae88": [{
      "hkey": "6be9a46b",
      "slug": "vighizzolo-ro",
      "name": "Vighizzolo-Ro",
      "primary": true,
      "skipSearch": false
    }],
    "ro": [{
      "hkey": "6be9a46b",
      "slug": "vighizzolo-ro",
      "name": "Vighizzolo-Ro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "montichiari"
    }],
    "5423da44": [{
      "hkey": "6be9a46b",
      "slug": "vighizzolo-ro",
      "name": "Vighizzolo-Ro",
      "primary": true,
      "skipSearch": false
    }],
    "vighizzolo": [{
      "hkey": "6be9a46b",
      "slug": "vighizzolo-ro",
      "name": "Vighizzolo-Ro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;